import { InferType } from 'yup';
import { schema } from 'components/GuestDetailsModal/helpers';
import { EditDetailsPopUpActionType, EDIT_DETAILS_POP_UP_ACTION, editDetailsPopUp } from 'lib/gaTracking/bookingDetailsPageEvents';
import { typedKeys } from 'lib/utils/types';

type FormValuesKey = keyof FormValues;
type ActionMap = { [K in Partial<FormValuesKey>]: EditDetailsPopUpActionType };

export type FormValues = InferType<typeof schema>;

export const trackUpdatedValue = (existingValues: FormValues, updatedValues: FormValues) => {
  const actionMap: Partial<ActionMap> = {
    email: EDIT_DETAILS_POP_UP_ACTION.EMAIL_ADDRESS_UPDATED,
    phone: EDIT_DETAILS_POP_UP_ACTION.PHONE_NUMBER_UPDATED,
    qffNumber: EDIT_DETAILS_POP_UP_ACTION.QFF_UPDATED,
    businessNumber: EDIT_DETAILS_POP_UP_ACTION.ABN_UPDATED,
  };

  typedKeys(existingValues).forEach((key) => {
    const isDirty = existingValues[key] !== updatedValues[key];
    const action = actionMap[key];
    if (isDirty && action) {
      editDetailsPopUp(action);
    }
  });
};

export const trackEditDetailsPopUp = () => editDetailsPopUp(EDIT_DETAILS_POP_UP_ACTION.SAVE_CHANGES_BUTTON_SELECTED);
